var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4294 2.34321C16.8317 1.23046 15.7534 0.152162 14.6406 0.555361L1.04082 5.47382C-0.0756574 5.87795 -0.210678 7.40135 0.816407 7.99637L5.15754 10.5096L9.03402 6.63313C9.20964 6.46351 9.44486 6.36966 9.68901 6.37178C9.93316 6.3739 10.1667 6.47183 10.3394 6.64448C10.512 6.81712 10.6099 7.05067 10.6121 7.29483C10.6142 7.53898 10.5203 7.77419 10.3507 7.94981L6.47422 11.8263L8.98839 16.1674C9.58248 17.1945 11.1059 17.0586 11.51 15.943L16.4294 2.34321Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.cc81f87c20900f7924299b4447ca4578.svg";
export { ForwardRef as ReactComponent };